<template>
  <div>
    <CSelect
      :options="selectItems"
      :value="selectedLimit"
      @input="onChangeSelect($event)"
    />
    <CPagination
      class="pagination"
      align="center"
      :active-page="activePage"
      :pages="pages"
      :double-arrows="false"
      @update:activePage="onUpdateActivePage"
    />
  </div>
</template>
<script>
import {
  auctionManagerStore,
  createAuctionManagerMixin
} from "@/mixins/auctionsManagerMixin";

const SELECT_ITEMS_PER_PAGE = [10, 50, 100];

export default {
  name: "VUserManagerTable",

  mixins: [createAuctionManagerMixin()],

  props: {
    itemPerPage: {
      type: Number,
      default: 10
    },
    itemsCount: {
      type: Number,
      defalt: 120
    },
    currentPage: {
      type: Number
    }
  },

  data: () => ({
    activePage: 1,
    selectedLimit: SELECT_ITEMS_PER_PAGE[0],
    pages: 0
  }),

  computed: {
    selectItems() {
      return [...SELECT_ITEMS_PER_PAGE];
    }
  },

  watch: {
    [auctionManagerStore.getterTypes.GETTER_AUCTIONS]() {
      this.setInitData();
    }
  },

  created() {
    this.setInitData();
  },

  methods: {
    setInitData() {
      const options = this.getPrevQuery();
      this.activePage = Math.floor(options.skip / options.take) + 1;
      this.pages = Math.ceil(
        this[auctionManagerStore.getterTypes.GETTER_AUCTIONS_COUNT] /
          options.take
      );
      this.selectedLimit = options.take || SELECT_ITEMS_PER_PAGE[0];
    },
    onChangeSelect(event) {
      const nextQuery = {
        ...this.getPrevQuery(),
        skip: 0,
        take: event.target.value
      };
      this.$router.push({ query: nextQuery });
    },
    onUpdateActivePage(toPage) {
      const prevQuery = this.getPrevQuery();
      const nextQuery = {
        ...prevQuery,
        skip: prevQuery.take * parseInt(toPage - 1)
      };
      this.$router.push({ query: nextQuery });
    },
    getPrevQuery() {
      const obj = {
        skip: parseInt(this.$route.query.skip) || 0,
        take: parseInt(this.$route.query.take) || this.selectItems[0]
      };

      if (this.$route.query.search) {
        obj.search = this.$route.query.search;
      }

      return obj;
    }
  }
};
</script>
